import { render, staticRenderFns } from "./RenewalsGlobalPlansView.vue?vue&type=template&id=6211372d&scoped=true&"
import script from "./RenewalsGlobalPlansView.vue?vue&type=script&lang=js&"
export * from "./RenewalsGlobalPlansView.vue?vue&type=script&lang=js&"
import style0 from "./RenewalsGlobalPlansView.vue?vue&type=style&index=0&id=6211372d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6211372d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardTitle,VChip,VDataTable,VIcon,VSpacer})
